export const ROOT_API = process.env.VUE_APP_ROOT_API
export const APP_TITLE = process.env.VUE_APP_TITLE
export const APP_LOCALE = process.env.VUE_APP_I18N_LOCALE
export const APP_ID = process.env.VUE_APP_I18N_LOCALE === 'tr' ? 1 : 2

// The public site. The app links out to it for the pages it no longer serves.
export const WEBSITE_URL = 'https://onlineicdenetim.com'
// Neta's address, the one the sign-up texts and the public site give
export const CONTACT_EMAIL = 'info@netadenetim.com'
